import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from "react-bootstrap";
import { useEffect } from "react";
import { config } from "../../constants/config";
import { TextParagraph } from "react-bootstrap-icons";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";



export default function AddRule() {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [fetching, setFetching] = useState(false);

    const [lib1, setLib1] = useState("");
    const [action, setAction] = useState("");
    const [desc, setDesc] = useState("");
    const [parent, setParent] = useState("");
    const [rules, setRules] = useState([]);
    const [edit, setedit] = useState(true);
    const [defaut, setdefaut] = useState(false);

    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showWarningMessage = (msg) => {
        toast.warning(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccessMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const handleedit = () => {
        setedit(!edit);
    };

    const handledefaut = () => {
        setdefaut(!defaut);
    };

    const getListRules = async () => {
        // setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        // var urlencoded = new URLSearchParams();
        // urlencoded.append("cpte", user.code);
        // urlencoded.append("prof", user.profil);
        // urlencoded.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/rights`, requestOptions).then((response) => {

            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];


                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            if (element.codeparent === null) {
                                clientarraydata.push({ label: element.lib, value: element.code });
                            }
                        });

                        setRules(clientarraydata);
                        // setLoading(false);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("data error: fail");
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {

                // console.log("response error: not 200 statut");
            }

        }).catch((err) => {
            // console.log("cash error: ", err);;
        });
    }



    // comportements
    useEffect(() => {
        getListRules();
    }, [])

    const handleSubmit = async (e) => {

        e.preventDefault();

        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();
        urlencoded.append("lib", lib1);
        urlencoded.append("action", action);
        urlencoded.append("descr", desc);
        urlencoded.append("defaut", defaut);
        urlencoded.append("edit", edit);
        if (parent) urlencoded.append("codeparent", parent["value"]);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/rights`, requestOptions).then((response) => {
            if (response?.status === 200 || response?.status === 201) {
                response.json().then(async (data) => {
                    // console.log("resonse ajout droit", data);
                    if (!data?.head) {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else if (data?.body?.msg === "le champ action de valeur gererforfait existe déjà;") {
                            setFetching(false);
                            showWarningMessage("Cette action est déjà utilisé par un autre droit.");
                        } else {
                            setFetching(false);
                            showErrorMessage("Echec d'ajout du droit! Veuillez reassayer plutard.");
                        }
                    } else {
                        setFetching(false);
                        showSuccessMessage(textes.fr.oparationsuccess);
                        navigate(-1);
                    }

                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                setFetching(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
            setFetching(false);
        });
    }


    // affichages
    return (
        <div className="container-fluid">
            <h1 className="h4 mb-4 font-weight-bold text_primary">Droits</h1>
            <div className="row">
                <div className="col-md-12">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3">
                            <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                <i className="fa fa-reply"></i> <span>Go Back</span>
                            </button>
                            <h6 className="m-0 ">Informations du droit</h6>
                        </div>
                        <div className="card-body">
                            <form style={{ width: "100%" }} onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <label htmlFor="lib" className="mb-1">Libelle</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="lib">
                                                        <TextParagraph />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Entrez le libelle du droit"
                                                        value={lib1}
                                                        onChange={(e) => setLib1(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <label htmlFor="action" className="mb-1">Action</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="action">
                                                        <TextParagraph />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Entrez le code action du droit"
                                                        value={action}
                                                        onChange={(e) => setAction(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <label className="mb-1" htmlFor="parent">Parent</label>
                                                <Select
                                                    id="parent"
                                                    name="parent"
                                                    options={rules}
                                                    value={parent}
                                                    placeholder="Sélectionnez le droit parent"
                                                    onChange={(selected) => {
                                                        setParent(selected);
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-12 mb-3">
                                                <label htmlFor="desc" className="mb-1">Description du droit</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="desc">
                                                        <TextParagraph />
                                                    </span>
                                                    <textarea
                                                        className="form-control"
                                                        placeholder="Aucune description"
                                                        value={desc}
                                                        style={{ height: 154 }}
                                                        onChange={(e) => setDesc(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12 mb-3">
                                                <div className="form-check">
                                                    <input type="checkbox" id="defaut"
                                                        className="form-check-input"
                                                        checked={defaut}
                                                        onChange={handledefaut}
                                                    />
                                                    <label htmlFor="defaut" className="mb-1 form-check-label">Par défaut</label>
                                                </div>
                                            </div>
                                            <div className="col-md-12 mb-3">
                                                <div className="form-check">
                                                    <input type="checkbox" id="edit"
                                                        className="form-check-input"
                                                        checked={edit}
                                                        onChange={handleedit}
                                                    />
                                                    <label htmlFor="edit" className="mb-1 form-check-label">Modifiable</label>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <button type="submit"
                                            title="Ajouter un nouveau droit"
                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                            disabled={lib1 && action ? false : true}
                                        >
                                            <i className="fa fa-check mr-2"></i>
                                            <span>Ajouter</span> {fetching && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}